let apidaePrestasPaginate = {

    props: {
        loadPaginate: Boolean,
        uri: String,
        typePaginate: String,
        params: Object
    },
    computed: {

    },
    components: {

    },
    directives: {

    },
    data() {
        return {

        }
    },
    methods: {
        paginateEvent(url) {
            this.$root.callPaginate(lodash.unescape(url))
        },
    },
    mounted: function () {
        if (this.typePaginate == "INFINITE") {
            window.onscroll = () => {
                let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
                if (bottomOfWindow && (parseInt(this.params.curPage) < parseInt(this.params.nbPages))) {
                    let url = lodash.unescape(this.params.nextPage)
                    this.$root.callPaginate(url)
                }
            }
        }
    },
    template: `
        <div class="paginate">
            <div v-show="loadPaginate" class="loading"></div>
            <div class="paginateAjax text-center" v-if="typePaginate != 'INFINITE' && (parseInt(params.curPage) < parseInt(params.nbPages))">
                <button class="button" @click="paginateEvent(params.nextPage)" :disabled="!params.nextPage">Plus de résultats</button>
            </div>
        </div>`
}

// <div class="paginatePager" :class="typePaginate == 'INFINITE' ? 'visuallyhidden' : ''" >
//     <button class="button" @click="paginateEvent(params.prevPage)" :disabled="!params.prevPage"> Previous </button>
//     <span>Page {{ params.curPage }} of {{ params.nbPages }}</span>
//     <button class="button" @click="paginateEvent(params.nextPage)" :disabled="!params.nextPage"> Next </button>
// </div>